import { defineMessages } from 'react-intl';

export const i18n: {
	filterByIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	filterByIcon: {
		id: 'quick-find-filters.filter-by-icon-label',
		defaultMessage: 'Filter by Icon',
		description:
			'Accessible label for the filter icon in the Quick Find dialog filters area, used to communicate the purpose of the icon to screen readers.',
	},
});
